import { render, staticRenderFns } from "./ConsuntivoMacchineMulti.vue?vue&type=template&id=b2d72f8c&scoped=true&"
import script from "./ConsuntivoMacchineMulti.vue?vue&type=script&lang=js&"
export * from "./ConsuntivoMacchineMulti.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2d72f8c",
  null
  
)

export default component.exports